// extracted by mini-css-extract-plugin
export default {"header":"PositionHeader_header__wMNRn","leftContent":"PositionHeader_leftContent__woc+c","rightContent":"PositionHeader_rightContent__ITQ2S"};